import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useTheme } from '../context/ThemeContext';

const { FiSun, FiMoon, FiMonitor } = FiIcons;

const ThemeToggle = () => {
  const { theme, changeTheme } = useTheme();

  const themes = [
    { key: 'light', icon: FiSun, label: 'Claro' },
    { key: 'dark', icon: FiMoon, label: 'Oscuro' },
    { key: 'auto', icon: FiMonitor, label: 'Auto' }
  ];

  return (
    <div className="flex bg-gray-100 dark:bg-gray-800 rounded-lg p-1">
      {themes.map(({ key, icon, label }) => (
        <motion.button
          key={key}
          onClick={() => changeTheme(key)}
          className={`p-2 rounded-md transition-all ${
            theme === key
              ? 'bg-white dark:bg-gray-700 shadow-sm text-primary-blue dark:text-primary-pink'
              : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
          }`}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          title={label}
          aria-label={`Tema ${label}`}
        >
          <SafeIcon icon={icon} className="w-4 h-4" />
        </motion.button>
      ))}
    </div>
  );
};

export default ThemeToggle;